import React from "react";
import { FormGroup, FormLabel } from "react-bootstrap";
import { isSafari } from "react-device-detect";
import { useTranslation } from "react-i18next";
import TimeInputWithArrows from "components/TimeInputWithArrows";

const TimeConfigModal = ({
	isOpen,
	onClose,
	onAccept,
	tempTimeConfig,
	onTimeChange,
	title,
	description,
	description2
}) => {
	const { t } = useTranslation();

	if (!isOpen) return null;

	title = title ?? t("timeConfigModal.title");
	description = description ?? t("timeConfigModal.description");
	description2 = description2 ?? t("timeConfigModal.description2");

	const isEmptyStartSafari =
		isSafari &&
		(tempTimeConfig.start === null || tempTimeConfig.start === undefined);
	const isEmptyEndSafari =
		isSafari &&
		(tempTimeConfig.end === null || tempTimeConfig.end === undefined);
	const displayStart = isEmptyStartSafari ? "00:00" : tempTimeConfig.start;
	const displayEnd = isEmptyEndSafari ? "00:00" : tempTimeConfig.end;

	return (
		<div className="time-config-modal-overlay">
			<div className="time-config-modal-container">
				<div className="time-config-modal-header">
					<h5 className="time-config-modal-title">
						{title}
					</h5>
					<button
						type="button"
						className="time-config-modal-close"
						onClick={onClose}
					>
						&times;
					</button>
				</div>

				<div className="time-config-modal-body">
					<p className="time-config-modal-description">
						{description}
					</p>
					<p className="time-config-modal-description">
						{description2}
					</p>
					<div className="time-config-modal-fields">
						<div className="time-config-modal-field">
							<FormGroup controlId="start" className="form-group form-group-time">
								<FormLabel>
									{t("timeConfigModal.startTime")} <span className="label-required">*</span>
								</FormLabel>
								<TimeInputWithArrows
									id="start"
									value={displayStart}
									onChange={onTimeChange}
									required
									placeholder="HH:mm"
									className={`${isEmptyStartSafari ? "is-safari is-empty" : ""}`}
									nextInputId="end"
								/>
							</FormGroup>
						</div>
						<div className="time-config-modal-field">
							<FormGroup controlId="end" className="form-group form-group-time">
								<FormLabel>
									{t("timeConfigModal.endTime")} <span className="label-required">*</span>
								</FormLabel>
								<TimeInputWithArrows
									id="end"
									value={displayEnd}
									onChange={onTimeChange}
									required
									placeholder="HH:mm"
									className={`${isEmptyEndSafari ? "is-safari is-empty" : ""}`}
								/>
							</FormGroup>
						</div>
					</div>
				</div>

				<div className="time-config-modal-footer">
					<button
						type="button"
						className="btn btn-outline-primary"
						onClick={onClose}
					>
						{t("common.cancel")}
					</button>
					<button
						type="button"
						className="btn btn-primary"
						onClick={onAccept}
					>
						{t("common.accept")}
					</button>
				</div>
			</div>
		</div>
	);
};

export default TimeConfigModal;
